import { Defaults } from '../api/searchApiConstants';

// Pickleball UTR-P ratings top out at 10, whereas tennis singles/doubles UTR runs
// 0-16.5. The pickleball sport filter applies { utrTeamType: 'doubles', utrMin: 1,
// utrMax: 10 } as its rating default — a configuration that is only valid for a
// pickleball-only search.
export const PICKLEBALL_UTR_CEILING = 10;

/**
 * HUB-1178: the pickleball-only rating config (doubles team type + the UTR-P ceiling
 * of 10) must never apply to a player search that includes tennis. When such a search
 * is established from a source that carries the leaked config — a URL-hydrated landing
 * (iOS-shaped link or stale bookmark), or a cleared-filters regression — the max-10
 * ceiling is imposed on the tennis doublesUtr field (0-16.5) and silently drops the
 * top-ranked players from a general search (Arthur Fils surfaced above Jannik Sinner).
 *
 * This resets the leaked default back to the tennis defaults so a general search stays
 * unbounded unless the user has genuinely narrowed the range. The exact pickleball
 * default triple is matched so a user who manually narrowed the range is left untouched.
 *
 * @param {Object} filters - the filters object about to be applied to search state
 * @returns {Object} the filters, with a leaked pickleball rating default reset to tennis defaults
 */
export const normalizePlayerRatingFilters = (filters) => {
    if (filters?.type !== 'players') {
        return filters;
    }

    const tennisSelected = !!filters.sportTypes?.tennis;
    const hasLeakedPickleballRatingDefault = filters.utrTeamType === 'doubles' &&
        Number(filters.utrMin) === Defaults.DEFAULT_UTR_MIN &&
        Number(filters.utrMax) === PICKLEBALL_UTR_CEILING;

    if (tennisSelected && hasLeakedPickleballRatingDefault) {
        return {
            ...filters,
            utrTeamType: 'singles',
            utrMin: Defaults.DEFAULT_UTR_MIN,
            utrMax: Defaults.DEFAULT_UTR_MAX,
        };
    }

    return filters;
};

export default normalizePlayerRatingFilters;
